import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'en', 
    fallbackLocale: 'en', 
    messages :{
        en: {
            about_description_1: 'We are currently a group of friends, who create and develop some video games in our spare time.',
            about_description_2: 'And maybe one day live from this passion.',
            about: 'about',
            us: 'Us',
            about_menu: 'About',
            games_menu: 'Games',
            press_menu: 'Press Kit',
            contact_menu: 'Contact',
            genre_endless_runner: 'Endless runner',
            genre_arcade: 'Arcade',
            snowy_description: 'You control Snowy, a snowman who must flee in the face of a devastating wave. But that\'s not the only danger! Be careful not to stay too long in the sun or you\'ll melt quickly!',
            robbery_bear_description: 'You control a Bear belonging to the "Bear club". Your goal is to steal the rarest objects to fill your hideout and to build your reputation among the greatest villains!',
            available_on: 'Available on',
            see_more_on: 'See more on',
            website: 'Website',
            copyright: '© 2020 Skear. All rights reserved. Skear, Skear.fr and the Skear logo are registered trademarks of the Skear Company.',
            legal_disclaimer: 'Terms and conditions of use',
            privacy_policy: 'Privacy Policy',
            our: 'Our',
            games: 'Games',
            contact: 'Contact',
            contact_us: 'Us',
            lead_developer: 'CTO / LEAD DEVELOPER',
            developer: 'DEVELOPER',
            project_manager: 'PROJECT MANAGER',
            d3_modeler: '3D MODELER',
            administration:  'ADMINISTRATION',
            community_manager: 'COMMUNITY MANAGER',
            quality_assurance: 'QUALITY ASSURANCE',
            tester: 'TESTER',
            social_title: 'SOCIAL',
            social_activity_next_title: 'ACTIVITY'
        },
        fr: {
            about_description_1: 'Nous sommes actuellement un groupe d\'amis, qui créent et développent des jeux vidéo pendant notre temps libre.',
            about_description_2: 'Et peut-être un jour vivre de cette passion.',
            about: 'À propos de ',
            us: 'Nous',
            about_menu: 'À propos',
            games_menu: 'Nos Jeux',
            press_menu: 'Press Kit',
            contact_menu: 'Contactez-nous',
            genre_endless_runner: 'Endless runner',
            genre_arcade: 'Arcade',
            snowy_description: 'Vous contrôlez Snowy, un bonhomme de neige qui doit fuir face à une vague dévastatrice. Mais ce n\'est pas le seul danger ! Faites attention à ne pas rester trop longtemps au soleil ou vous fondrez rapidement !',
            robbery_bear_description: 'Vous contrôlez un ours faisant partie du "Bear Club" dont le but est d\'exposer dans leur planque les objets volés les plus rares dans l\'intention de se faire une réputation parmi les plus grands vilains.',
            available_on: 'Disponible sur',
            see_more_on: 'voir plus sur',
            website: 'Site web',
            copyright: '© 2020 Skear. Tous droits réservés. Skear, Skear.fr et le logo Skear sont des marques déposées de la société Skear.',
            legal_disclaimer: 'Mentions légales',
            privacy_policy: 'Politique de confidentialité',
            our: 'Nos',
            games: 'Jeux',
            contact: 'Contactez',
            contact_us: 'Nous',
            lead_developer: 'DIRECTEUR TECHNIQUE / DÉVELOPPEUR',
            developer: 'DÉVELOPPEUR',
            project_manager: 'CHEF DE PROJET',
            d3_modeler: 'MODELEUR 3D',
            administration:  'ADMINISTRATION',
            community_manager: 'RESPONSABLE COMMUNICATION',
            quality_assurance: 'ASSURANCE QUALITÉ',
            tester: 'TESTEUR',
            social_title: 'RÉSEAU SOCIAUX',
            social_activity_next_title: 'ACTIVITÉ'
        }
    }
});

// vue localisation :
// https://medium.com/hypefactors/add-i18n-and-manage-translations-of-a-vue-js-powered-website-73b4511ca69c
// https://www.freecodecamp.org/news/how-to-add-internationalization-to-a-vue-application-d9cfdcabb03b/